import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    state:{
        token:  localStorage.getItem('token') || null,
        tokenDM:  localStorage.getItem('tokenDM') || null,
        validationDelivery: false,
        logo: true,
        details: false,
        hideFooter: true,
        activeDialogOrders: false,
        newUserData: 
        {
            codigo_marca: null, 
            nombre: null,
            apellidos: null,
            correo: null, 
            pass: null, 
            fecha_nac: null, 
            genero: null, 
            telefono: null,
            direccion: null, 
        },
        datos_pedido:
        {
            id_cliente: null,
            id_sucursal: null,
            id_direccion: null,
            metodo_entrega: null,
            metodo_pago: null,
            monto_total: null,
            comentarios: null,
            platillos:[{
                id_platillo: null,
                cantidad: null,
                precio_unitario: null,
                adicionales:[{
                    id_adicional: null,
                    cantidad: null,
                }],
                modificadores:[{
                    id_modififcador: null,
                    cantidad: null,
                }],
            }]
        },
        lista_platillos:  JSON.parse(localStorage.getItem('platillos')) || [],
        id_cliente:  localStorage.getItem('id_cliente') || null,
        nombre_cliente:  localStorage.getItem('nombre_cliente') || null,
        id_sucursal:  localStorage.getItem('id_sucursal') || null,
        colors: {
            primary: "#91C3E8",
            secondary: "#7C7B7D",
            accent: "#EDE1AC",
            buttons: "magenta",

        },
        precio_details_footer: null,
        precio_adicionales_footer: null,
        counter_footer: null,
        cantidad_footer: null,
        codigo_marca: localStorage.getItem('codigo_marca') || null,
        menu: null,
        footer_search: "",
        notifications_amount: 0,
        userCards: [],
        modificators_flag: false,
        propina: null,
        alertState: false,
        alertMessage: 'Error',
        alertColor: 'warning',
        logoSRC: "",
        backImage: "",
        maxContValidation: null,
        counter_footerMUC0: 0,
        finishedData: {},
    },
    getters:{
        isAuthenticated: state => !!state.token,
        isAuthenticatedDM: state => !!state.tokenDM,
        islogo: state => state.logo,
        isdetails: state => state.details,
        isHideFooter: state => state.hideFooter,
      },
    mutations:{
        authUser (state, userData) {
            state.token = userData.token
            state.id_cliente = userData.id
            state.id_sucursal = userData.id_sucursal
            state.nombre_cliente = userData.nombre_cliente
        },
        authDelivery(state,deliveryData)
        {
            state.tokenDM= deliveryData.tokenDM;
            state.id_repartidor= deliveryData.id;
        },
        setPlatillos (){
            localStorage.setItem("platillos", [])
        }
    },
    actions:{
        POST: ({commit}, data) => {
            return new Promise((resolve, reject) => {
              axios.post(data.url, data.body, data.headers).then(response => {
                  console.log(response);
                  resolve(response);
                  commit
              }).catch(err => { reject(err);})
            })
        },
        GET: ({commit}, data) => {
            return new Promise((resolve, reject) => {
              axios.get(data.url, { headers: data.headers }).then(response => {
                //   console.log(response);
                  resolve(response);
                  commit
              }).catch(err => { reject(err);})
            })
        },
        PUT: ({commit}, data) => {
            return new Promise((resolve, reject) => {
              axios.put(data.url, data.body,data.headers).then(response => {
                  console.log(response);
                  resolve(response);
                  commit
              }).catch(err => { reject(err); })
            })
        },
        DELETE: ({commit}, data) => {
            return new Promise((resolve, reject) => {
              axios.delete(data.url,data.headers).then(response => {
                  console.log(response);
                  resolve(response);
                  commit
              }).catch(err => { reject(err); })
            })
        },
        signup({commit}, authData){
            return new Promise((resolve, reject) => {
                axios.post(
                    '/altaC',
                    {
                        nombre: authData.nombre,
                        apellido: authData.apellidos,
                        correo: authData.correo,
                        pass: authData.pass,
                        fecha_nac: authData.fecha_nac,
                        genero: authData.genero,
                        telefono: authData.telefono
                    }, 
                    {headers: authData.headers}
                )
                    .then(res =>{ 
                    console.log("Res->Registro: ",res);    
                    commit         
                    resolve(res);
                    }) 
                    .catch(err => { console.log(err); reject(err);  })
            })
        },
        login({commit}, authData){
            return new Promise((resolve, reject) => {
                axios.post('/loginC',
                {
                    user: authData.user,
                    pass: authData.pass,
                    codigo_marca: authData.codigo_marca
                }, 
                {headers: authData.headers})
                    .then(res =>{
                        // console.log("Res->Inicio de sesión: ",res);  
                        if(res.data.error == "")
                        {
                            commit('authUser',{
                                token: res.data.token, 
                                id: res.data.id,
                                nombre_cliente: res.data.nombre
                            })
                            localStorage.setItem("token",res.data.token);
                            localStorage.setItem("nombre_cliente",res.data.nombre);
                            localStorage.setItem("id_cliente",res.data.id);
                            localStorage.setItem('id_sucursal',res.data.id_sucursal)  
                            localStorage.setItem("original_id_sucursal",res.data.id_sucursal)
                            localStorage.setItem('email', authData.user)                               
                        }
                        resolve(res);
                    }) 
                    .catch(err => { console.log(err); reject(err);  })
            });
        },
        loginDelivery({commit}, authData){
            return new Promise((resolve, reject) => {
                axios.post('/loginR',
                {
                    user: authData.user,
                    pass: authData.pass
                }, 
                {headers: authData.headers})
                    .then(res =>{
                        console.log("Res->Inicio de sesión: ",res);  
                        if(res.data.error == "")
                        {
                            commit('authDelivery',{
                                tokenDM: res.data.token, 
                                id: res.data.id
                            })
                            localStorage.setItem("tokenDM",res.data.token);
                            localStorage.setItem("id_repartidor",res.data.id);
                            localStorage.setItem("id_sucursal",res.data.id_sucursal);
                            localStorage.setItem("original_id_sucursal",res.data.id_sucursal)
                        }
                        resolve(res);
                    }) 
                    .catch(err => { console.log(err); reject(err);  })
            });
        },
        initilizePedido(){
            return new Promise((resolve, reject) => {
                var x = [];
                // localStorage.removeItem('platillos');
                localStorage.setItem('platillos', JSON.stringify(x));
                // localStorage.setItem('platillos', []);
                // console.log("Voa inicializar pedido");
                // console.log(typeof localStorage.getItem('platillos'));
                if(localStorage.getItem('platillos') == null)
                    reject(false);
                else
                    resolve(true);
            });
        }
    },
    
});